export async function validateImageDimensions(
  file: File,
  expectedWidth: number,
  expectedHeight: number
): Promise<boolean> {
  return new Promise(resolve => {
    const image = new window.Image();
    const imageUrl = URL.createObjectURL(file);
    image.src = imageUrl;

    image.onload = () => {
      const isValid =
        image.width === expectedWidth && image.height === expectedHeight;

      URL.revokeObjectURL(imageUrl);
      resolve(isValid);
    };

    image.onerror = () => {
      URL.revokeObjectURL(imageUrl);
      resolve(false);
    };
  });
}
